<template>
  <div>
    <notifications
      position="top right"
      classes="smartbooks-notification"
      :duration="5000"
    />
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { captureVerifyToken } from "@/helpers/onboard";
export default {
  methods: mapActions({
    observeUser: "observeUser",
  }),
  async created() {
    captureVerifyToken(this.$route);
    this.observeUser();
  }
};
</script>
